import React, {useState, useRef, useEffect} from 'react'
import clsx from 'clsx'
import {NotificationModel} from '../../../app/entities/entities'
import {getNotificationMessage} from '../../../app/modules/user/helper/helperFunction'

export interface NotificationDropdownProps {
  notifications: NotificationModel[]
  onClearNotifications?: () => void
}

const NotificationDropdown: React.FC<NotificationDropdownProps> = ({
  notifications,
  onClearNotifications,
}) => {
  const [isDropdownOpen, setDropdownOpen] = useState(false)
  const dropdownRef = useRef<HTMLDivElement>(null)

  const handleIconClick = () => {
    setDropdownOpen((prev) => !prev)
  }

  const handleClearAll = () => {
    onClearNotifications?.()
  }

  const handleNotificationClick = (notification: NotificationModel) => {
    setDropdownOpen(false)
  }

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownOpen(false)
      }
    }
    if (isDropdownOpen) {
      document.addEventListener('mousedown', handleClickOutside)
    } else {
      document.removeEventListener('mousedown', handleClickOutside)
    }
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [isDropdownOpen])

  return (
    <div className={clsx('app-navbar-item position-relative')} ref={dropdownRef}>
      <button
        type='button'
        className='btn btn-icon btn-active-light-primary btn-custom'
        onClick={handleIconClick}
        data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
        data-kt-menu-attach='parent'
        data-kt-menu-placement='bottom-end'
      >
        <i className='fas fa-bell fa-lg btn-active-light-primary btn-custom hover-primary' />
        {notifications.length > 0 && (
          <span className='position-absolute top-1 right-3 start-100 translate-middle p-1 bg-danger border border-light rounded-circle notification-tooltip' />
        )}
      </button>

      {isDropdownOpen && (
        <div className='position-absolute top-100 end-0 w-300px bg-white border rounded shadow-sm mt-2'>
          <div className='p-2 border-bottom d-flex justify-content-between align-items-center'>
            <strong>Notifications</strong>
            {notifications.length > 0 && (
              <button
              type='button'
              className='btn btn-sm btn-link text-decoration-none'
              onClick={handleClearAll}
            >
              Mark as read
            </button>
            )}
          </div>
          <div className='overflow-auto ' style={{ maxHeight: '350px' }} >
            {notifications.length > 0 ? (
              notifications.map((n) => (
                <div
                  key={n.id}
                  className={clsx(
                    'cursor-pointer border p-3 m-3 rounded-4 notification-item',
                    n.read_at ? 'text-muted' : 'fw-bold'
                  )}  
                  onClick={() => handleNotificationClick(n)}
                >
                  {getNotificationMessage(n)}
                </div>
              ))
            ) : (
              <div className='p-2 text-center text-muted'>No notifications</div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default NotificationDropdown
